import React, { useEffect, useState, Component } from 'react'
import { Link, useNavigate, Navigate } from 'react-router-dom'
import FormValidator from '../FormValidator';
import { withRouter } from '../withRouter';
import swal from 'sweetalert2';
//import logo from 'src/assets/images/avatars/Logo02.png';
import logo from 'src/assets/images/avatars/Logo-kalima.svg';
import 'src/scss/input_css.scss'
import 'src/scss/new_design.scss'
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

window.Swal = swal;
class ForgotPassword extends Component {

  constructor(props) {

    const resetPassword = sessionStorage.getItem('resetPassword');
    if (resetPassword) {
      Swal.fire('Sucess!', 'Your password successfully changed', 'success');
      sessionStorage.removeItem('resetPassword');
    }

    super(props);
    this.validator = new FormValidator([
     {
        field: 'email',
        method: 'isEmpty',
        validWhen: false,
        message: 'The Email field is required.'
      }, {
        field: 'email',
        method: 'isEmail',
        validWhen: true,
        message: 'Enter valid email address.'
      }
    ]);
    this.state = {
      email: '',
      password: '',
      data: [],
      validation: this.validator.valid(),
    }

    this.submitted = false;
    this.isLoading = true;


      const registerUser = sessionStorage.getItem('user_register');

  if (registerUser == "true") {
    toast.success('Your registration form successfully submitted!', {
      position: "top-center",
      autoClose: 5000,
      hideProgressBar: true,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
      theme: "light",
    });
    sessionStorage.setItem("user_register", false);
  }
  }
  handleChange = event => {
    event.preventDefault();
    this.setState({
      [event.target.name]: event.target.value,
    });
  }

  handleFormSubmit = async event => { 
    this.isLoading = true;
    event.preventDefault();
    const validation = this.validator.validate(this.state);
    this.setState({
      validation
    });
    this.submitted = true;
    if (validation.isValid) {  
      //reaches here if form validates successfully... 
      let email = this.state.email;
      let password = this.state.password;

      let result = await fetch(window.apiFetchBaseURL + 'auth/forgot-password', {
        method: 'post',
        body: JSON.stringify({
          email: email,
          password: password,
        }),
        headers: {
          "access-control-allow-origin": "*",
          'Content-Type': 'application/json'
        }
      }).then(function (response) {
        return response.json();
      }).catch(function (e) {
        alert("We are facing technical issue.");
      });


      if (result.status == true) {
         sessionStorage.setItem('password_reset_email', email);         
         this.props.navigate("/verify-otp");

      } else {
        alert(result.message);
      }
      this.isLoading = true;
    }
  }



  render() {

    let validation = this.submitted ? this.validator.validate(this.state) : this.state.validation;
    return (

      <div class="container">   
        <ToastContainer /> 
        <div class="row d-flex justify-content-center">
          <div class="col-sm-4 col-lg-4 col-xl-4 col-xs-12 user_card" style={{ "margin-top": "69px" }}>
            <div className='row justify-content-center' style={{"margin-top": "20px"}}>
              <img src={logo} class="Logo" alt="Logo" />
            </div>
            <div class="d-flex justify-content-center form_container">
              <div className='col-12'>
                <form>
                  <div class=" input-group mb-3" >
                    <div className="form-outline">
                      <input className={validation.email.message || this.state.email ? "form-control active " : " form-control "} type="text" id="Username" name='email' onChange={this.handleChange} />
                      <label className={validation.email.message ? "form-label label-color" : " form-label"} htmlFor="Username">Email <span style={{ "color": "#c13818" }}>*</span></label>
                      <div className="form-notch">
                        <div className={validation.email.message ? "form-notch-leading border-error-color" : "form-notch-leading"} style={{ "width": "9px" }}>    </div>
                        <div className={validation.email.message ? "form-notch-middle border-error-color-midd" : "form-notch-middle"} style={{ "width": "50.4px" }}></div>
                        <div className={validation.email.message ? "form-notch-trailing border-error-color" : "form-notch-trailing"} ></div>
                      </div>
                    </div>
                  </div>
                 

                  <div class="mt-4">                   
                    <div class="d-flex justify-content-center " >
                      <Link to="/login" class="Create-an-Account">Login</Link>
                    </div>
                  </div>


                  <div className="Actions-2 mt-3" onClick={this.handleFormSubmit}>
                    <div className="Web-Button">
                      <a style={{ "color": "white" }} className='register-button' >
                        Reset Password
                      </a>
                    </div>
                  </div>


                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default withRouter(ForgotPassword)
